import React, { useState, useEffect, useRef } from 'react';
// Using placeholder images for demonstration. Replace with your actual asset imports.
import hero_img from '@/assets/images/dating_hero.png';
import couple_img from '@/assets/dating_assets/hero.jpg';
import brand_img from '@/assets/images/bro.jpg';
import smiling_man from '@/assets/images/smiling_man.webp';
import MarkDownView from '@/components/MarkDownView';

// Import avatar images
import image_1 from '@/assets/dating_assets/people_1.jpeg';
import image_2 from '@/assets/dating_assets/people_2.jpeg';
import image_3 from '@/assets/dating_assets/people_3.jpeg';
import image_4 from '@/assets/dating_assets/people_4.jpeg';
import image_5 from '@/assets/dating_assets/people_5.jpeg';
import image_6 from '@/assets/dating_assets/people_6.jpeg';

// Import review images (chat screenshots)
import review_2 from '@/assets/dating_assets/review_2.jpg';
import review_3 from '@/assets/dating_assets/review_3.jpg';
import review_4 from '@/assets/dating_assets/review_4.jpg';
import review_5 from '@/assets/dating_assets/review_5.jpg';

// --- Lucide-React Icons (as functional components for demonstration) ---
// In a real project, you would import these from 'lucide-react'.
const MessageCircleHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M7.9 20A9 9 0 0 0 12 22a9 9 0 0 0 4.1-2" />
    <path d="M12 22V4" />
    <path d="M7.4 4.5A2.5 2.5 0 0 1 9.5 3h5a2.5 2.5 0 0 1 2.1 1.5" />
    <path d="m10.5 12-1.5 6" />
    <path d="m13.5 12 1.5 6" />
    <path d="M5 9v2" />
    <path d="M19 9v2" />
  </svg>
);
const Shirt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
  </svg>
);
const Smartphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
    <path d="M12 18h.01" />
  </svg>
);
const BrainCircuit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.585A3 3 0 1 0 12 17a3 3 0 1 0 5.997-.125 4 4 0 0 0 2.526-5.77 4 4 0 0 0-.556-6.585A3 3 0 1 0 12 5z" />
    <path d="M12 5a2.5 2.5 0 0 0-2.5 2.5" />
    <path d="M12 17a2.5 2.5 0 0 1 2.5-2.5" />
    <path d="M12 5a2.5 2.5 0 0 1 2.5 2.5" />
    <path d="M12 17a2.5 2.5 0 0 0-2.5-2.5" />
    <path d="M5.023 11.2a2.5 2.5 0 0 0-2.526 2.5" />
    <path d="M18.977 11.2a2.5 2.5 0 0 1 2.526 2.5" />
    <path d="M5.023 11.2a2.5 2.5 0 0 1 2.526-2.5" />
    <path d="M18.977 11.2a2.5 2.5 0 0 0-2.526-2.5" />
  </svg>
);
const Handshake = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="m11 17 2 2a1 1 0 1 0 3-3" />
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.5-3.5a2 2 0 0 0-2.83-2.83" />
    <path d="M9.06 11.5 4.5 7a1 1 0 0 0-3 3l6 6" />
    <path d="M15.5 12.5 17 14l-3 3" />
    <path d="m7 15 3 3" />
  </svg>
);
const BarChart4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M3 3v18h18" />
    <path d="M13 17V9" />
    <path d="M18 17V5" />
    <path d="M8 17v-3" />
  </svg>
);
const Bot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M12 8V4H8" />
    <rect width="16" height="12" x="4" y="8" rx="2" />
    <path d="M2 14h2" />
    <path d="M20 14h2" />
    <path d="M15 13v2" />
    <path d="M9 13v2" />
  </svg>
);
const CheckCircle2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const Zap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const ShieldCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const Instagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);
const Twitter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const Linkedin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

// --- Data Configuration ---
const courseData = {
  meta: {
    title: 'Brogrammers.in - Master Social Confidence & Dating Skills',
    description:
      'Stop getting ignored. Start getting noticed. Our AI-powered platform helps you master social confidence, communication, and dating skills. A product of ZenshkoolAI Pvt Ltd.',
    favicon:
      'https://raw.githubusercontent.com/dashingvinit/Brogrammers-AI-frontend/refs/heads/main/public/favicon_bro.ico?token=GHSAT0AAAAAADHATVBPONE75W3Y7NM7JM4A2D3WVSQ',
    ogImage: 'https://raw.githubusercontent.com/brogrammers-in/assets/main/brogrammers_og_image.png',
  },
  brandName: 'Brogrammers',
  logoSrc: brand_img,
  companyName: 'ZenshkoolAI Pvt Ltd',
  heroTagline: 'Stop Getting Ignored. Start Getting Noticed.',
  heroHeadline: 'Date Like a Man',
  heroSubheadline: 'Learn the little things that change everything. Limited Time: 98% OFF!',
  heroVisual: {
    type: 'image',
    src: couple_img,
    alt: 'Confident young man smiling while texting on his phone',
  },
  heroCTA: 'Get Instant Access →',
  heroOriginalPrice: '₹4999',
  heroDiscountPrice: '₹99',
  heroCTASubtext: '🔥 1000+ Happy Users | 💡 90% see results in 7 days | ⚡ Instant Access',
  paymentLink: 'https://rzp.io/rzp/wN1xohO',
  trustText: 'Instant Access. Secure Checkout.',
  trustLogos: [
    'https://vinit-jains-bucket.s3.ap-south-1.amazonaws.com/image+(1).png',
    'https://vinit-jains-bucket.s3.ap-south-1.amazonaws.com/android-chrome-192x192.png',
    'https://cdn.razorpay.com/logo.svg',
  ],
  topBuyNowButton: {
    text: 'Buy Now',
    originalPrice: '₹4999',
    discountPrice: '₹99',
    link: 'https://rzp.io/rzp/wN1xohO',
  },
  testimonials: [
    {
      avatar: image_1,
      quote: 'Best ₹99 I ever spent. I finally stopped being so awkward around girls and actually know what to say.',
      name: 'Ankit S.',
      rating: 5,
    },
    {
      avatar: image_2,
      quote: "It's like a friend telling you straight what works and what's just BS. No fluff, just the facts.",
      name: 'Rohit K.',
      rating: 5,
    },
    {
      avatar: image_3,
      quote:
        'My confidence has soared! The AI Wingman is a game-changer for practicing real-life scenarios without the pressure.',
      name: 'Sameer P.',
      rating: 5,
    },
    {
      avatar: image_4,
      quote:
        "Before this, I'd just freeze up. Now, I can actually hold a conversation without my mind going blank. Huge thanks!",
      name: 'Deepak V.',
      rating: 5,
    },
    {
      avatar: image_5,
      quote: 'I used to overthink every single text. The AI Wingman helped me sound more natural and confident.',
      name: 'Mehul G.',
      rating: 5,
    },
    {
      avatar: image_6,
      quote:
        "This course simplified everything about dating for me. It's practical, actionable, and genuinely helpful.",
      name: 'Rahul T.',
      rating: 5,
    },
  ],
  successStories: [
    {
      image: review_2,
      title: 'No More Awkward Silences',
      description: 'The AI wingman helped me practice until I felt confident. Now conversations flow naturally.',
      name: 'Karan, 27',
    },
    {
      image: review_3,
      title: 'From Friend-zone to Dating',
      description: 'Applied the dating psychology lessons and successfully asked out my college crush.',
      name: 'Vikram, 25',
    },
    {
      image: review_4,
      title: 'Texting Game Changed Everything',
      description: 'Learned the art of texting that keeps them interested. Game changer!',
      name: 'Rohan, 26',
    },
    {
      image: review_5,
      title: 'Confidence Through the Roof',
      description: "The course didn't just teach tactics, it built real confidence from within.",
      name: 'Aditya, 23',
    },
  ],
  benefitsList: [
    {
      icon: MessageCircleHeart,
      title: 'Master Conversation',
      text: 'Talk to anyone without sounding desperate or awkward.',
    },
    { icon: Shirt, title: 'Develop Your Style', text: 'Style yourself to actually stand out (in a good way).' },
    { icon: Smartphone, title: 'Dominate Texting', text: 'Master the unspoken rules of texting that actually work.' },
    {
      icon: BrainCircuit,
      title: 'Build Core Confidence',
      text: 'Fix your confidence from the inside out, not just on the surface.',
    },
    {
      icon: Handshake,
      title: 'Create Real Connections',
      text: 'Build genuine connections, not just use pickup lines.',
    },
    {
      icon: BarChart4,
      title: 'Elevate Your Game',
      text: 'Understand social dynamics & elevate your entire social life.',
    },
  ],
  mvpFeature: {
    headline: 'Your Personal AI Wingman',
    description:
      "No more awkward silences or missed cues. Our AI Wingman lets you practice conversations, test texts, and get instant feedback. It's like having a dating coach in your pocket, 24/7.",
    icon: Bot,
    graphic: hero_img,
    ctaText: 'Try the AI Demo',
    ctaLink: '#ai-wingman-section',
  },
  chatbotSection: {
    headline: 'Meet Your AI Wingman: Practice Before it Counts!',
    description:
      "Don't know what to text? Our AI simulates conversations for you. Get instant feedback and refine your approach before you hit send.",
    ctaText: 'Get Full Access for Just ₹99',
    ctaLink: 'https://rzp.io/rzp/wN1xohO',
    messageSuggestions: ['Hey!', 'You looked amazing today 😄', 'Want to hang out this weekend?'],
  },
  finalCTAHeadline: 'Stop Waiting. Start Changing.',
  finalCTAButton: 'Get Instant Access →',
  finalOriginalPrice: '₹4999',
  finalDiscountPrice: '₹99',
  finalPaymentLink: 'https://rzp.io/rzp/wN1xohO',
  finalTrustBadges: [
    { icon: ShieldCheck, text: 'Secure Payment' },
    { icon: Zap, text: 'Instant Access' },
    { icon: CheckCircle2, text: '100% Private' },
  ],
  footer: {
    description:
      'Brogrammers is an AI-powered learning platform for mastering social confidence, dating skills, and communication.',
    quickLinks: [
      { text: 'Home', href: 'https://brogrammers.in' },
      { text: 'Buy Now', href: 'https://rzp.io/rzp/DjVTpTd0' },
      { text: 'Testimonials', href: '#testimonials' },
      { text: 'AI Demo', href: '#ai-wingman-section' },
    ],
    legalLinks: [
      { text: 'Privacy Policy', href: '/privacy-policies' },
      { text: 'Terms of Service', href: '/terms-conditions' },
    ],
    socialLinks: [
      { name: 'Instagram', href: 'https://www.instagram.com/brogrammers_ai/', icon: Instagram },
      { name: 'Twitter', href: 'https://x.com/Brogrammer_ai', icon: Twitter },
      { name: 'LinkedIn', href: 'https://www.linkedin.com/company/brogrammers-ai', icon: Linkedin },
    ],
    contactEmail: 'support@brogrammers.in',
    copyrightText: `© ${new Date().getFullYear()} Brogrammers.in — A product of ZenshkoolAI Pvt Ltd. All Rights Reserved.`,
  },
};

// --- Reusable Components ---

const CountdownTimer = ({ hours = 3 }) => {
  const targetTimeRef = useRef(new Date(new Date().getTime() + hours * 60 * 60 * 1000));
  const [timeLeft, setTimeLeft] = useState({ hours: '00', minutes: '00', seconds: '00' });

  useEffect(() => {
    const timer = setInterval(() => {
      const difference = targetTimeRef.current - new Date();
      if (difference > 0) {
        const h = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const m = Math.floor((difference / 1000 / 60) % 60);
        const s = Math.floor((difference / 1000) % 60);
        setTimeLeft({
          hours: h.toString().padStart(2, '0'),
          minutes: m.toString().padStart(2, '0'),
          seconds: s.toString().padStart(2, '0'),
        });
      } else {
        setTimeLeft({ hours: '00', minutes: '00', seconds: '00' });
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-center justify-center sm:justify-start gap-2 font-mono bg-red-500/10 text-red-500 px-3 py-1.5 rounded-full border border-red-500/20">
      <span className="font-semibold text-sm">Offer ends in:</span>
      <span className="tracking-widest text-base font-bold">
        {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}
      </span>
    </div>
  );
};

const StarRating = ({ rating }) => (
  <div className="flex justify-center my-2">
    {Array.from({ length: 5 }, (_, i) => (
      <svg
        key={i}
        className={`w-5 h-5 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.368 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.921-.755 1.688-1.54 1.118l-3.368-2.448a1 1 0 00-1.175 0l-3.368 2.448c-.784.57-1.838-.197-1.539-1.118l1.287-3.957a1 1 0 00-.364-1.118L2.25 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69L9.049 2.927z" />
      </svg>
    ))}
  </div>
);

const SectionHeader = ({ children, className = '' }) => (
  <div className={`text-center mb-12 sm:mb-16 ${className}`}>
    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">{children}</h2>
    <div className="mt-4 h-1.5 w-24 bg-gradient-to-r from-pink-500 to-red-500 rounded-full mx-auto"></div>
  </div>
);

const TestimonialCard = ({ testimonial, isHidden = false }) => (
  <div
    className="inline-block w-[340px] lg:w-[30%] mx-4 bg-white p-8 rounded-2xl shadow-lg flex flex-col items-center text-center transform transition-transform duration-300 flex-shrink-0 whitespace-normal border border-gray-100"
    aria-hidden={isHidden}>
    <img
      src={testimonial.avatar}
      alt={testimonial.name}
      className="w-24 h-24 rounded-full object-cover mb-4 border-4 border-white shadow-md"
      loading="lazy"
    />
    <StarRating rating={testimonial.rating} />
    <p className="italic text-lg text-gray-700 mb-4 leading-relaxed break-words">"{testimonial.quote}"</p>
    <p className="font-bold text-gray-900 text-lg">— {testimonial.name}</p>
  </div>
);

const BenefitCard = ({ benefit }) => (
  <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-start space-y-4 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-gray-100 hover:border-pink-300">
    <div className="bg-gradient-to-br from-pink-100 to-red-100 p-4 rounded-full">
      <benefit.icon className="w-8 h-8 text-red-500" />
    </div>
    <h3 className="text-xl font-bold text-gray-900">{benefit.title}</h3>
    <p className="text-gray-600 leading-relaxed">{benefit.text}</p>
  </div>
);

const SuccessStoryCard = ({ story }) => (
  <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
    <div className="relative">
      <img src={story.image} alt={story.title} className="w-full h-64 object-cover" loading="lazy" />
      <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold">
        ✓ SUCCESS
      </div>
    </div>
    <div className="p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-2">{story.title}</h3>
      <p className="text-gray-600 mb-4 leading-relaxed">"{story.description}"</p>
      <p className="text-pink-600 font-semibold">— {story.name}</p>
    </div>
  </div>
);

// Enhanced Testimonials Component with Swipe Support
const TestimonialsSection = ({ testimonials }) => {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }
    if (isRightSwipe) {
      setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    }
  };

  return (
    <section id="testimonials" className="py-20 sm:py-24 px-4 bg-gray-50">
      <div className="mx-auto">
        <SectionHeader>What Our Users Say</SectionHeader>
        
        {/* Desktop: Auto-scroll version */}
        <div className="hidden md:block relative overflow-hidden group py-8">
          <div className="flex animate-scroll-left whitespace-nowrap">
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <TestimonialCard
                key={index}
                testimonial={testimonial}
                isHidden={index >= testimonials.length}
              />
            ))}
          </div>
          <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent"></div>
          <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent"></div>
        </div>

        {/* Mobile: Swipe version */}
        <div className="md:hidden">
          <div
            className="relative overflow-hidden py-8"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            ref={containerRef}>
            <div 
              className="flex transition-transform duration-300 ease-out"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`
              }}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <TestimonialCard testimonial={testimonial} />
                </div>
              ))}
            </div>
          </div>
          
          {/* Swipe Indicators */}
          <div className="flex justify-center space-x-2 mt-4">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-200 ${
                  index === currentIndex ? 'bg-pink-500' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
          
          {/* Swipe Hint */}
          <p className="text-center text-sm text-gray-500 mt-2">
            👈 Swipe to see more testimonials 👉
          </p>
        </div>
      </div>
    </section>
  );
};

// AI Wingman Chatbot Component
const AIChatbot = ({ chatbotData }) => {
  const [lovedOneName, setLovedOneName] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [currentMessage, setCurrentMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const chatEndRef = useRef(null);

  const handleStartSimulation = () => {
    if (lovedOneName.trim() === '') {
      setChatHistory([{ role: 'ai', text: 'Please enter a name to start the simulation!' }]);
      return;
    }
    setChatHistory([
      {
        role: 'ai',
        text: `Alright! I'm your AI Wingman. Let's practice chatting with ${lovedOneName}. Want tips on breaking the ice and starting the conversation?`,
      },
    ]);
  };

  const handleSendMessage = async (messageToSend) => {
    const text = (typeof messageToSend === 'string' ? messageToSend : currentMessage).trim();
    if (text === '' || isLoading) return;

    const newChatHistory = [...chatHistory, { role: 'user', text }];
    setChatHistory(newChatHistory);
    setCurrentMessage('');
    setIsLoading(true);

    try {
      const prompt = `You are an AI assistant helping a user practice chatting with their crush named ${lovedOneName}. Your tone is like a cool, supportive but honest friend. Your goal is to make the user sound more confident, witty, and authentic. Give direct feedback or suggest better replies. Keep responses concise and natural.

      Conversation History:
      ${newChatHistory.map((msg) => `${msg.role === 'user' ? 'User' : 'AI Wingman'}: ${msg.text}`).join('\n')}
      
      Your response as the AI Wingman:`;

      const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
      if (!apiKey) {
        // Simulate a response for the demo when API key is not present
        setTimeout(() => {
          const simulatedResponses = [
            `That's a good start! Maybe add an emoji to make it more playful? Like 'Hey! 😊'`,
            `Solid opener. What are you hoping to talk about with ${lovedOneName}?`,
            `Instead of just 'Hey', how about mentioning something you have in common? Like, 'Hey! Saw you at the gym earlier, you were crushing it.'`,
            `Confident and to the point. I like it. Let's see how ${lovedOneName} might reply.`,
          ];
          const aiResponse = simulatedResponses[Math.floor(Math.random() * simulatedResponses.length)];
          setChatHistory((prev) => [...prev, { role: 'ai', text: aiResponse }]);
          setIsLoading(false);
        }, 1200);
        return; // End execution here for the demo
      }

      const payload = { contents: [{ role: 'user', parts: [{ text: prompt }] }] };
      const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const result = await response.json();
      let aiResponse = 'Oops! My circuits are buzzing. Try again.';
      if (result.candidates?.[0]?.content?.parts?.[0]?.text) {
        aiResponse = result.candidates[0].content.parts[0].text;
      }
      setChatHistory((prev) => [...prev, { role: 'ai', text: aiResponse }]);
    } catch (error) {
      console.error('Error communicating with AI:', error);
      setChatHistory((prev) => [
        ...prev,
        { role: 'ai', text: `Demo Mode: ${error.message}. This is a simulated response.` },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="ai-wingman-section" className="py-20 sm:py-24 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <SectionHeader>Meet Your AI Wingman</SectionHeader>
        <p className="text-lg text-gray-600 mb-10 -mt-8 max-w-2xl mx-auto">{chatbotData.description}</p>
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-2 rounded-3xl shadow-2xl">
          <div className="bg-gray-900/80 backdrop-blur-lg p-6 sm:p-8 rounded-2xl border border-white/10">
            {!chatHistory.length ? (
              <div className="space-y-6">
                <input
                  type="text"
                  placeholder="Enter their name (e.g., 'Maya')"
                  className="w-full p-4 rounded-xl border border-gray-600 focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none text-white bg-gray-800 placeholder-gray-400 text-center text-lg"
                  value={lovedOneName}
                  onChange={(e) => setLovedOneName(e.target.value)}
                />
                <button
                  onClick={handleStartSimulation}
                  className="bg-gradient-to-r from-pink-500 to-red-500 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-pink-500/40 transition-all duration-300 ease-in-out transform hover:-translate-y-1">
                  Start Simulation
                </button>
              </div>
            ) : (
              <div className="flex flex-col h-[450px] border border-gray-700 rounded-xl overflow-hidden bg-gray-800/50">
                <div className="flex-1 p-4 overflow-y-auto">
                  {chatHistory.map((msg, index) => (
                    <div key={index} className={`mb-4 flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                      <span
                        className={`inline-block p-3 rounded-2xl max-w-[80%] text-white ${
                          msg.role === 'user'
                            ? 'bg-pink-600 rounded-br-none shadow'
                            : 'bg-gray-700 rounded-bl-none shadow'
                        }`}>
                        {msg.text}
                      </span>
                    </div>
                  ))}
                  {isLoading && (
                    <div className="text-left mb-4 flex justify-start">
                      <span className="inline-block p-3 rounded-2xl bg-gray-700 text-white rounded-bl-none animate-pulse">
                        AI Wingman is typing...
                      </span>
                    </div>
                  )}
                  <div ref={chatEndRef} />
                </div>
                <div className="p-4 bg-gray-900/80 border-t border-gray-700">
                  <div className="flex space-x-3">
                    <input
                      type="text"
                      placeholder="Type your message..."
                      className="flex-1 p-3 rounded-lg border border-gray-600 focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none text-white bg-gray-800"
                      value={currentMessage}
                      onChange={(e) => setCurrentMessage(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') handleSendMessage();
                      }}
                      disabled={isLoading}
                    />
                    <button
                      onClick={() => handleSendMessage()}
                      className="bg-gradient-to-r from-pink-500 to-red-500 text-white px-6 py-3 rounded-lg font-bold shadow-md hover:shadow-lg transition-all duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
                      disabled={isLoading}>
                      Send
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2 mt-3 justify-center">
                    {chatbotData.messageSuggestions.map((suggestion) => (
                      <button
                        key={suggestion}
                        onClick={() => handleSendMessage(suggestion)}
                        className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-sm hover:bg-gray-600 transition-colors"
                        disabled={isLoading}>
                        {suggestion}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

// --- Main App Component ---
function App() {
  // Effect for setting up meta tags
  useEffect(() => {
    const setMetaTag = (attr, value, content) => {
      let element = document.querySelector(`meta[${attr}='${value}']`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, value);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    document.title = courseData.meta.title;
    setMetaTag('name', 'description', courseData.meta.description);
    setMetaTag('property', 'og:title', courseData.meta.title);
    setMetaTag('property', 'og:description', courseData.meta.description);
    setMetaTag('property', 'og:image', courseData.meta.ogImage);
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', courseData.meta.title);
    setMetaTag('name', 'twitter:description', courseData.meta.description);
    setMetaTag('name', 'twitter:image', courseData.meta.ogImage);
    let faviconLink = document.querySelector('link[rel="icon"]');
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }
    faviconLink.href = courseData.meta.favicon;
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-sans antialiased">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Roboto+Mono:wght@400;700&display=swap');
        html { font-family: 'Inter', sans-serif; scroll-behavior: smooth; }
        .font-mono { font-family: 'Roboto Mono', monospace; }
        @keyframes scroll-left { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .animate-scroll-left { animation: scroll-left 40s linear infinite; }
        .group:hover .animate-scroll-left { animation-play-state: paused; }
        .bg-grid-pattern { background-image: linear-gradient(to right, #e5e7eb 1px, transparent 1px), linear-gradient(to bottom, #e5e7eb 1px, transparent 1px); background-size: 3rem 3rem; }
      `}</style>

      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md shadow-sm py-3 px-6 border-b border-gray-200/80">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <a href="#" className="flex items-center gap-3">
            <img
              src={courseData.logoSrc}
              alt={`${courseData.brandName} Logo`}
              className="h-10 w-10 object-cover rounded-full bg-gray-800 p-1"
            />
            <span className="text-xl font-bold text-gray-800">{courseData.brandName}</span>
          </a>
          <a
            href={courseData.topBuyNowButton.link}
            className="inline-flex flex-col items-center bg-gradient-to-r from-pink-500 to-red-500 text-white px-5 py-2.5 rounded-lg font-bold text-sm shadow-lg hover:shadow-red-500/30 transition-all duration-300 ease-in-out transform hover:-translate-y-0.5">
            <div className="flex items-center gap-2">
              <span className="text-xs line-through opacity-70">{courseData.topBuyNowButton.originalPrice}</span>
              <span className="text-sm">{courseData.topBuyNowButton.discountPrice}</span>
            </div>
            <span className="text-xs">{courseData.topBuyNowButton.text}</span>
          </a>
        </div>
      </header>

      <main>
        <section className="relative w-full min-h-screen flex flex-col items-center justify-center text-center px-4 py-16 overflow-hidden pt-24 bg-rose-50/50">
          <div className="absolute inset-0 bg-grid-pattern opacity-50"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-white via-rose-50/50 to-white"></div>
          <div className="relative z-10 max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
            <div className="lg:w-1/2 text-center sm:text-left lg:pr-12">
              <p className="text-lg sm:text-xl bg-gradient-to-r from-pink-500 to-red-500 bg-clip-text text-transparent font-bold uppercase tracking-wider mb-4">
                {courseData.heroTagline}
              </p>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-tight mb-6 text-gray-900">
                {courseData.heroHeadline}
              </h1>
              <p className="text-lg text-gray-600 mb-8 max-w-lg mx-auto sm:mx-0">{courseData.heroSubheadline}</p>

              <div className="flex flex-col items-center sm:items-start gap-4">
                <div className="w-full sm:w-auto flex flex-col items-center sm:items-start">
                  <div className="flex items-center gap-4 mb-2">
                    <span className="text-2xl line-through text-red-500 opacity-70">
                      {courseData.heroOriginalPrice}
                    </span>
                    <span className="text-4xl font-semibold text-pink-600">{courseData.heroDiscountPrice}</span>
                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold">98% OFF</span>
                  </div>
                  <a
                    href={courseData.paymentLink}
                    className="w-full sm:w-auto inline-block bg-gradient-to-r from-pink-500 to-red-500 text-white px-8 py-4 sm:px-10 sm:py-5 rounded-xl font-bold text-xl shadow-lg hover:shadow-red-500/40 transition-all duration-300 ease-in-out transform hover:-translate-y-1">
                    {courseData.heroCTA}
                  </a>
                </div>
                <div className="flex flex-col items-center sm:items-start gap-3 w-full">
                  <CountdownTimer hours={2} />
                  <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 text-center">
                    <p className="text-red-600 font-bold text-sm">⚠️ Only 47 spots left at this price!</p>
                  </div>
                </div>
                <p className="mt-4 text-sm text-gray-600 font-semibold">{courseData.heroCTASubtext}</p>
                <div className="mt-4 flex justify-center sm:justify-start items-center space-x-6 flex-wrap">
                  {courseData.trustLogos.map((logoSrc, index) => (
                    <img
                      key={index}
                      src={logoSrc}
                      alt="Payment Trust Logo"
                      className="h-8 opacity-80"
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="lg:w-1/2 mt-12 lg:mt-0">
              <div className="relative">
                <div className="absolute -inset-2 bg-gradient-to-br from-pink-400 to-red-500 rounded-3xl blur-xl opacity-50"></div>
                <img
                  src={courseData.heroVisual.src}
                  alt={courseData.heroVisual.alt}
                  className="relative w-full h-auto rounded-3xl shadow-2xl object-cover border-4 border-white"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 sm:py-24 bg-gray-900 text-white px-4">
          <div className="max-w-5xl mx-auto text-center">
            <div className="w-24 h-24 bg-white/10 border border-white/20 rounded-full flex items-center justify-center text-white mb-8 mx-auto shadow-lg backdrop-blur-sm">
              <courseData.mvpFeature.icon className="w-12 h-12" />
            </div>
            <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight mb-6">{courseData.mvpFeature.headline}</h2>
            <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
              {courseData.mvpFeature.description}
            </p>
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-br from-pink-600 to-red-600 rounded-2xl blur-2xl opacity-40"></div>
              <img
                src={courseData.mvpFeature.graphic}
                alt="AI Wingman Feature Graphic"
                className="relative w-full max-w-3xl h-auto rounded-2xl shadow-2xl border border-gray-700 mx-auto mb-12"
                loading="lazy"
              />
            </div>
            <a
              href={courseData.mvpFeature.ctaLink}
              className="inline-block bg-white text-pink-600 px-10 py-5 rounded-xl font-bold text-xl uppercase tracking-wide shadow-lg hover:shadow-white/20 transition-all duration-300 ease-in-out transform hover:-translate-y-1">
              {courseData.mvpFeature.ctaText}
            </a>
          </div>
        </section>

        <TestimonialsSection testimonials={courseData.testimonials} />

        <section className="py-20 sm:py-24 px-4 bg-white">
          <div className="max-w-7xl mx-auto">
            <SectionHeader>Real Results From Real Users</SectionHeader>
            <p className="text-center text-lg text-gray-600 mb-12 -mt-8 max-w-2xl mx-auto">
              See how our users went from awkward to confident and landed their dream dates
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {courseData.successStories.map((story, index) => (
                <SuccessStoryCard key={index} story={story} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 sm:py-24 px-4 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            <SectionHeader>Everything You'll Master</SectionHeader>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {courseData.benefitsList.map((benefit, index) => (
                <BenefitCard key={index} benefit={benefit} />
              ))}
            </div>
          </div>
        </section>

        <AIChatbot chatbotData={courseData.chatbotSection} />

        <section className="py-20 sm:py-24 bg-gradient-to-br from-gray-800 to-black text-white text-center px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight mb-6">{courseData.finalCTAHeadline}</h2>
            <div className="flex items-center justify-center gap-6 mb-8">
              <span className="text-3xl line-through text-red-400 opacity-70">{courseData.finalOriginalPrice}</span>
              <span className="text-6xl font-semibold text-pink-400">{courseData.finalDiscountPrice}</span>
              <span className="bg-red-500 text-white px-4 py-2 rounded-full text-lg font-bold animate-pulse">
                LAST CHANCE!
              </span>
            </div>
            <a
              href={courseData.finalPaymentLink}
              className="inline-block bg-gradient-to-r from-pink-500 to-red-500 text-white px-12 py-6 rounded-xl font-bold text-2xl uppercase tracking-wide shadow-lg hover:shadow-red-500/40 transition-all duration-300 ease-in-out transform hover:-translate-y-1">
              {courseData.finalCTAButton}
            </a>
            <div className="mt-8 flex justify-center items-center gap-x-6 gap-y-4 flex-wrap">
              {courseData.finalTrustBadges.map((badge, index) => (
                <div key={index} className="flex items-center text-gray-300 text-base font-medium">
                  <badge.icon className="text-green-400 w-6 h-6 mr-2" />
                  {badge.text}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-gray-900 text-gray-400 pt-16 pb-10 px-6 sm:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <a href="#" className="flex items-center gap-3 mb-4">
                <img
                  src={courseData.logoSrc}
                  alt={`${courseData.brandName} Logo`}
                  className="h-12 w-12 object-cover rounded-full bg-gray-800 p-1"
                />
                <span className="text-2xl font-bold text-white">{courseData.brandName}</span>
              </a>
              <p className="text-sm">{courseData.footer.description}</p>
            </div>
            <div>
              <h3 className="font-bold text-white uppercase tracking-wider mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {courseData.footer.quickLinks.map((link) => (
                  <li key={link.text}>
                    <a href={link.href} className="hover:text-white transition-colors">
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-white uppercase tracking-wider mb-4">Legal & Contact</h3>
              <ul className="space-y-2">
                {courseData.footer.legalLinks.map((link) => (
                  <li key={link.text}>
                    <a href={link.href} className="hover:text-white transition-colors">
                      {link.text}
                    </a>
                  </li>
                ))}
                <li>
                  <a href={`mailto:${courseData.footer.contactEmail}`} className="hover:text-white transition-colors">
                    {courseData.footer.contactEmail}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-white uppercase tracking-wider mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                {courseData.footer.socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    aria-label={social.name}
                    className="hover:text-white transition-colors">
                    <social.icon className="w-6 h-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-10 pt-6 text-center text-sm text-gray-500">
            <p>{courseData.footer.copyrightText}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
